"use strict";require("./_string-html")("fontcolor",function(t){return function(r){return t(this,"font","color",r)}});